import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationEnvatoPurchasePost = {
    path: "/envato/purchase",
    method: ERouteHttpVerb.POST
};
export { routeLocationEnvatoPurchasePost };
